export const TYPE_BALANCE_UPDATE = 'player/balance-update'
export const TYPE_STATUS_UPDATE = 'player/status-update'

export const PING_MESSAGE = 'ping'
// The ALB drops connections idle for 60s, so ping well within that window.
export const PING_INTERVAL_MS = 30000
export const RECONNECT_BASE_DELAY_MS = 1000
export const RECONNECT_MAX_DELAY_MS = 30000
// A connection must stay up this long before the backoff resets, so a server
// that accepts and immediately closes is not retried every second.
export const STABLE_CONNECTION_MS = 10000
